module.exports = __webpack_public_path__ + "static/media/scca-runoffs-2021@2x.304a1509.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/scca-runoffs-2021@2x.png
// module id = 1153
// module chunks = 0